<template>
  <common-modal
      :isShow="value"
      type="custom"
      close-on-click-modal
      :modal-width="popupInfo && popupInfo?.modalWidth ? popupInfo?.modalWidth : 590"
      @close="closeAgree">
    <!--隐私-->
    <div v-if="popupInfo?.type === 2" class="privacy-modal">
      <div class="privacy-modal-header">
        <h3 class="header-title">{{popupInfo?.title}}</h3>
      </div>
      <div class="privacy-modal-content">
        皇家加勒比集团始终重视并致力于保护您的个人信息，为帮助您更清晰、方便地了解关于个人信息收集场景、处理方式的更多详细信息，{{popupInfo?.changeNote}}您可以点击<a :href="privacyLink" class="privacy-link">《隐私政策》</a>以完整阅读更新后的内容，当您点击【同意并继续】时，即表示您已理解并同意该条款内容。
      </div>
      <div class="privacy-modal-footer">
        <button @click="cancelAgree">退出</button>
        <button class="is-agree" @click="submitAgree">同意并继续</button>
      </div>
    </div>
    <!--游享荟-->
    <div v-else-if="popupInfo?.type === 3" class="privacy-modal type-3">
      <div class="privacy-modal-header type-3">
        <div class="title-logo"></div>
        <div class="header-close" @click="closeAgree">
          <img class="icon" :src="`${imgUrl}/global/icons/iconCloseWhite.png`" alt="" />
        </div>
      </div>
      <div class="privacy-modal-content type-3">
        为持续完善会员服务机制，我们更新了《皇家游享荟项目细则》，{{popupInfo?.changeNote}}您可点击<a :href="rewardPrivacyLink" class="privacy-link">链接</a>了解具体内容，并仔细阅读。您也可咨询客服电话（4008207705）或在线客服。
      </div>
    </div>
  </common-modal>
</template>

<script>
const CommonModal = () => import("@/components/Common/CommonModal");
export default {
  name: "PrivacyModal",
  props: {
    value: {
      type: Boolean,
      required: false
    },
    userAgreementInfo: {
      type: Object,
      default: null
    }
  },
  watch: {
    value: {
      handler(val) {
        if(val) {
          const {type, changeNote} = this.userAgreementInfo;
          // 1:用户协议 2:隐私政策 3:皇家游享荟项目细则
          const popupInfoVal = {
            2: {
              title: "《隐私政策》更新提醒",
              modalWidth: 650,
              changeNote: changeNote,
              type: type
            },
            3: {
              title: "温馨提示",
              modalWidth: 560,
              changeNote: changeNote,
              type: type
            }
          }
          this.popupInfo = popupInfoVal[this.userAgreementInfo.type];
        }
      },
      immediate: true
    }
  },
  data() {
    return {
      imgUrl: process.env.VUE_APP_IMG_URL,
      visible: false,
      privacyLink: process.env.VUE_APP_BASE_URL + "/Rccl.UserCenter/Privacy",
      userAgreementLink: process.env.VUE_APP_BASE_URL + "/content/brand/legalinfo/repeat",
      rewardPrivacyLink: process.env.VUE_APP_BASE_URL + "/Rccl.UserCenter/RewardRule",
      popupInfo: null
    }
  },
  components: {
    CommonModal
  },
  methods: {
    cancelAgree() {
      this.$emit('submit',{ isAgree: false, type: this.userAgreementInfo.type });
    },
    submitAgree() {
      this.$emit('submit',{ isAgree: true, type: this.userAgreementInfo.type });
    },
    closeAgree() {
      this.submitAgree();
    }
  }
}
</script>

<style scoped lang="less">
.privacy-modal {
  border-radius: 8px;
  background-color: #fff;
  box-shadow: 0 4px 8px 0 rgba(0,0,0,0.3);
}
.privacy-modal-header {
  position: relative;
  font-size: 22px;
  text-align: center;
  padding: 40px 15px 15px;
  margin: 0;
  color: #333333;
  & h3 {
    margin: 0;
  }
  & .title-logo {
    width: 50px;
    height: 50px;
    background: url(https://resource.rcclchina.com.cn/logo/logoPopupBg.png);
    margin: 0 auto;
  }
  & .header-close {
    position: absolute;
    top: 10px;
    right: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 28px;
    width: 28px;
    border-radius: 28px;
    cursor: pointer;
    background-color: rgba(136,136,136,0.5);
    & .icon {
      height: 16px;
      width: 16px;
    }
  }
  &.type-3 {
    padding: 15px 15px 20px;
  }
}
.privacy-modal-content {
  padding: 0 15px;
  text-indent: 2em;
  line-height: 28px;
  min-height: 180px;
  max-height: 220px;
  overflow-x: hidden;
  overflow-y: auto;
  color: #333333;
  &.type-3 {
    padding: 0 48px 30px;
    font-size: 17px;
    text-indent: 0;
  }
}
.privacy-modal-footer {
  padding: 25px 0 40px;
  text-align: center;
  & > button {
    height: 36px;
    line-height: 36px;
    font-size: 16px;
    width: 110px;
    color: #333333;
    border: 1px solid #cccccc;
    background-color: #FFFFFF;
    &:hover {
      background-color: #F0F0F0;
    }
    &:active {
      background-color: #f7f7f7;
    }
    &.is-agree {
      margin-left: 10px;
      border: 1px solid #FBC500;
      background-color: #FBC500;
      &:hover {
        background-color: #daaa09;
      }
      &:active {
        background-color: #FBC500;
      }
    }
  }
}
</style>
